import React from "react";
import { Check } from "lucide-react";
import Reveal from "./Reveal";
import { pricing as P } from "../mock";

const PlanCard = ({ plan }) => {
  const dark = plan.dark;
  return (
    <div
      className={`rounded-[32px] p-8 md:p-10 flex flex-col ${
        dark ? "bg-[#0b0b0b] text-white" : "bg-white text-[#141414]"
      }`}
    >
      <img src={plan.icon} alt="" className="w-12 h-12 rounded-xl mb-6 object-contain" />
      <h3 className="font-cal text-2xl mb-3">{plan.name}</h3>
      <p className={`text-sm leading-relaxed mb-8 ${dark ? "text-[#9a9a9a]" : "text-[#5f5f5f]"}`}>
        {plan.desc}
      </p>

      <div className={`flex items-center justify-between text-sm pb-6 mb-6 border-b ${dark ? "border-white/10" : "border-[#e2e2e2]"}`}>
        <span className={dark ? "text-[#8a8a8a]" : "text-[#8a8a8a]"}>Delivery Time</span>
        <span className="font-medium">{plan.delivery}</span>
      </div>

      <div className="mb-8">
        {plan.priceLabel && (
          <div className={`text-sm mb-1 ${dark ? "text-[#8a8a8a]" : "text-[#8a8a8a]"}`}>{plan.priceLabel}</div>
        )}
        <div className="font-cal text-5xl flex items-end gap-1">
          {plan.price}
          {plan.per && <span className="text-lg font-normal text-[#8a8a8a] mb-1">{plan.per}</span>}
        </div>
      </div>

      <div className="space-y-4 mb-10">
        {plan.features.map((f) => (
          <div key={f} className="flex items-start gap-3 text-sm">
            <span className="w-5 h-5 mt-0.5 rounded-full bg-[#ff4d17] text-white flex items-center justify-center shrink-0">
              <Check size={12} />
            </span>
            <span className={dark ? "text-[#d5d5d5]" : "text-[#333]"}>{f}</span>
          </div>
        ))}
      </div>

      <button
        onClick={() => document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" })}
        className={`mt-auto w-full py-3.5 rounded-full font-medium transition-colors ${
          dark ? "bg-white text-[#0b0b0b] hover:bg-[#ff4d17] hover:text-white" : "bg-[#1c1c1c] text-white hover:bg-[#ff4d17]"
        }`}
      >
        Get Started
      </button>
    </div>
  );
};

const Pricing = () => {
  return (
    <section id="pricing" className="bg-[#ececec] py-24 md:py-32 px-5">
      <div className="max-w-[1100px] mx-auto">
        <Reveal>
          <p className="text-[#8a8a8a] text-sm mb-3">{P.eyebrow}</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-cal text-5xl md:text-7xl mb-14 text-[#141414]">{P.title}</h2>
        </Reveal>
        <div className="grid md:grid-cols-2 gap-6">
          {P.plans.map((plan, i) => (
            <Reveal key={plan.name} delay={i * 0.1}>
              <PlanCard plan={plan} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Pricing;
